type PaginacionProps = {
    page: number;           // página actual, base 0
    size: number;
    totalElements: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    onSizeChange: (size: number) => void;
    sizes?: number[];
}

const Paginacion = ({ page, size, totalElements, totalPages, onPageChange, onSizeChange, sizes = [10, 25, 50] }: PaginacionProps): JSX.Element => {
    const desde = totalElements === 0 ? 0 : page * size + 1;
    const hasta = Math.min((page + 1) * size, totalElements);
    const hayAnterior = page > 0;
    const haySiguiente = page + 1 < totalPages;

    return (
        <div className="row align-items-center mt-3">
            <div className="col-md-4">
                <label className="d-flex align-items-center mb-0">
                    <span className="me-2">Mostrar</span>
                    <select
                        aria-label="Cantidad de registros"
                        className="form-select form-select-sm w-auto"
                        value={size}
                        onChange={(e) => onSizeChange(Number(e.target.value))}
                    >
                        {sizes.map((s) => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                    <span className="ms-2">registros</span>
                </label>
            </div>
            <div className="col-md-4 text-center" aria-live="polite">
                Mostrando {desde} a {hasta} de {totalElements} registros
            </div>
            <div className="col-md-4 text-end">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary me-1"
                    disabled={!hayAnterior}
                    onClick={() => onPageChange(page - 1)}
                >
                    Anterior
                </button>
                <span className="mx-2">Página {totalPages === 0 ? 0 : page + 1} de {totalPages}</span>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary ms-1"
                    disabled={!haySiguiente}
                    onClick={() => onPageChange(page + 1)}
                >
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Paginacion;
